import otel, { Context } from '@opentelemetry/api';
import React, { FC, ReactNode } from 'react';

export const otelContext = React.createContext<Context>(otel.context.active());

export interface Props {
  children?: ReactNode;
  context: Context;
}

const OtelContextProvider: FC<Props> = (props) => {
  const { children, context } = props;

  return <otelContext.Provider value={context}>{children}</otelContext.Provider>;
};

export default OtelContextProvider;
